module.exports = __webpack_public_path__ + "static/media/downcast-face-with-sweat-svgrepo-com.87e037bd.svg";